import * as bootstrap from "bootstrap";
export default (window.bootstrap = bootstrap);
